module.exports = __webpack_public_path__ + "4771a0bf2bbfe967daf772895a5e2469.png";